import React from 'react'
import { FaMapMarkerAlt, FaCalendarAlt } from 'react-icons/fa'
import { getEventImage } from '../utils/eventImageUtils'

const EventContent = ({ event, onClick }) => {
  return (
    <div className="cursor-pointer" onClick={onClick}>
      {/* Event Image */}
      <div className="relative h-64 bg-gradient-to-br from-purple-600/20 to-pink-600/20">
        {getEventImage(event) ? (
          <img
            src={getEventImage(event)}
            alt={event.name}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <svg className="w-16 h-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 002 2z" />
            </svg>
          </div>
        )}
      </div>

      {/* Event Info */}
      <div className="p-6">
        <h3 className="text-2xl font-bold text-white mb-2">{event.name}</h3>

        <div className="flex flex-wrap gap-4 text-gray-300 text-sm mb-4">
          <div className="flex items-center gap-2">
            <FaMapMarkerAlt />
            <span>{event.venueName}, {event.country}</span>
          </div>
          <div className="flex items-center gap-2">
            <FaCalendarAlt />
            <span>{new Date(event.startDate).toLocaleDateString()}</span>
          </div>
        </div>

        {event.description && (
          <p className="text-gray-200 mb-4">{event.description}</p>
        )}

        {event.lineup && (
          <div className="mb-4">
            <h4 className="text-white font-semibold mb-2">Lineup:</h4>
            <p className="text-gray-200 text-sm">{event.lineup.replace(/,\s*/g, ' ')}</p>
          </div>
        )}

        {event.rating && (
          <div className="mb-4">
            <span className="text-yellow-400">
              {'★'.repeat(event.rating)}{'☆'.repeat(5 - event.rating)}
            </span>
            <span className="text-gray-300 ml-2">({event.rating}/5)</span>
          </div>
        )}

        {event.notes && (
          <div className="mb-4">
            <h4 className="text-white font-semibold mb-2">Notes:</h4>
            <p className="text-gray-200 text-sm">{event.notes}</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default EventContent